import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useTrackEvent from '../../utils/trackEvent';
import { Styling } from '@/types/customer';

function Home() {
  const [btnColor, setBtnColor] = useState<{ backgroundColor: string } | null>(null);
  const [logo, setLogo] = useState<string | null>(null);
  const [welcomeText, setWelcomeText] = useState<(string | JSX.Element)[] | string | null>(null);

  const trackEvent = useTrackEvent();
  useEffect(() => {
    trackEvent('PageView_Start', {});
  }, []);

  useEffect(() => {
    const defaultWelcomeText =
      'Met dit programma krijg je eenvoudig advies over hulpmiddelen die je kunt gebruiken om langer zelfstandig thuis te wonen. Door het beantwoorden van een aantal vragen krijg je vervolgens een advies.';
    if (window.customer) {
      setBtnColor({ backgroundColor: window.customer.primary_color });
      setLogo(window.customer.logo_url);
      let text = window.customer.welcome_text !== null && window.customer.welcome_text.length > 0
        ? window.customer.welcome_text
        : defaultWelcomeText;
      const lines = text.split('\n');
      const welcomeTextArr: (string | JSX.Element)[] = new Array(lines.length * 2 - 1);
      for (let i = 0; i < lines.length; i++) {
        welcomeTextArr[i * 2] = lines[i];
        if (i !== 0) welcomeTextArr[i * 2 - 1] = <br key={i} />;
      }
      setWelcomeText(welcomeTextArr);
    } else {
      setBtnColor({ backgroundColor: Styling.PrimaryColor() });
      setLogo('/assets/images/logo.png');
      setWelcomeText(defaultWelcomeText);
    }
  }, []);

  return (
    <section className="site-container">
      {btnColor && logo && (
        <div className="welcome min-h-[85vh]">
          <div className="logo-container">
            <img src={logo} alt="logo" />
          </div>
          <div className="max-w-[540px] mx-auto lg:ml-[25%]">
            <h1 className="welcome-title">Welkom</h1>
            <p className="welcome-body">{welcomeText}</p>
          </div>
          <div className="max-w-[600px] mx-auto lg:ml-[25%]">
            <p className="mb-4">Ik vul de vragenlijst in als:</p>
            <div className="flex flex-col lg:flex-row gap-4">
              <Link to="/questions" className="btn btn-primary" style={btnColor} onClick={() => trackEvent('Click_StartButton', { option: 'Een client of patient' })}>
                Een inwoner, cliënt of patiënt
                <i className="fas fa-chevron-right"></i>
              </Link>
              <Link to="/questions" className="btn btn-primary" style={btnColor} onClick={() => trackEvent('Click_StartButton', { option: 'Een familielid of kennis' })}>
                Een familielid, kennis of vrijwilliger
                <i className="fas fa-chevron-right"></i>
              </Link>
              <Link to="/questions" className="btn btn-primary" style={btnColor} onClick={() => trackEvent('Click_StartButton', { option: 'Professional' })}>
                Professional
                <i className="fas fa-chevron-right"></i>
              </Link>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Home;
